/**
 * FASE 8 — Colunas da lista pública de ranking (atletas).
 *
 * A lista NÃO é uma `<table>`: é um CSS grid com colunas de largura fixa. Como o
 * número de colunas MUDA (composição do total e 2º Bronze só aparecem quando
 * fazem sentido), os templates são montados aqui — função PURA, sem React e sem
 * DOM, o que permite testar a ordem e a largura sem jsdom.
 *
 * Ordem vigente (visão do usuário):
 *
 *     POS · ATLETA · EQUIPE · PART · PESO · PERFOR · 🥇 🥈 🥉 (2ºB) · PTS
 *
 * Regras aprovadas:
 *   * `PART`/`PESO`/`PERFOR` só existem no ranking federativo (livro de pontos);
 *   * no CELULAR essas três ficam OCULTAS (como a coluna Equipe já fica hoje):
 *     a linha fica `POS · ATLETA · medalhas · PTS`;
 *   * o 4º ícone (2º Bronze) só aparece quando o campeonato tem o 2º Bronze
 *     LIGADO (`second_bronze_enabled`).
 */

const MEDAL_WIDTH = '46px';
const MEDAL_WIDTH_MOBILE = '22px';
const COMPONENT_WIDTHS = ['52px', '52px', '56px'];

/** Larguras das colunas de medalha (3 ou 4 colunas). */
export function medalColumns(showSecondBronze) {
  const qtd = showSecondBronze ? 4 : 3;
  return Array.from({ length: qtd }, () => MEDAL_WIDTH);
}

/**
 * Templates do grid.
 *
 * @returns {{mobile: string, desktop: string, columns: string[]}} onde
 *          `columns` é a lista ordenada de rótulos das colunas na visão de
 *          DESKTOP (para teste e para o cabeçalho).
 */
export function buildRankingGrid({ showComponents = false, showSecondBronze = false } = {}) {
  const components = showComponents ? COMPONENT_WIDTHS : [];
  const medals = medalColumns(showSecondBronze);

  const desktop = ['50px', '1fr', 'minmax(120px,1fr)', ...components, ...medals, '60px'];
  const mobile = [
    '24px',
    '1fr',
    ...medals.map(() => MEDAL_WIDTH_MOBILE),
    '28px',
  ];

  const columns = [
    'POS', 'ATLETA', 'EQUIPE',
    ...(showComponents ? ['PART', 'PESO', 'PERFOR'] : []),
    'OURO', 'PRATA', 'BRONZE',
    ...(showSecondBronze ? ['SEGUNDO_BRONZE'] : []),
    'PTS',
  ];

  return {
    desktop: desktop.join(' '),
    mobile: mobile.join(' '),
    columns,
  };
}

/** Legenda das colunas de composição (vazia quando elas não aparecem). */
export function componentLegend(showComponents) {
  if (!showComponents) return [];
  return [
    { sigla: 'PART', texto: 'Participação' },
    { sigla: 'PESO', texto: 'Peso do campeonato' },
    { sigla: 'PERFOR', texto: 'Performance por tipo de vitória' },
  ];
}
